import CodeMaskedInput from './CodeMaskedInput';

export default CodeMaskedInput;
